import React from "react";
import PropTypes from "prop-types";
import Api from "js/api/authorisedApi";

const ClasslinkLoginButton = ({ deviceId }) => {
	const handleLoginWithClasslink = (event) => {
		Api.unauthenticatedGet("/login/oauth/classlink?deviceid=" + deviceId, (data) => {
			window.location = data.url;
		});

		event.preventDefault();
	};

	return (
		<button className="classlink-login-button" onClick={handleLoginWithClasslink}>
			<div className="classlink-logo" />
			<div className="login-text">Sign in with ClassLink</div>
		</button>
	);
};

ClasslinkLoginButton.propTypes = {
	deviceId: PropTypes.string.isRequired,
};

export default ClasslinkLoginButton;
